import {
	Control,
	FieldPath,
	FieldValues,
	useController,
} from "react-hook-form";
import { StyledSelect, StyledSelectProps } from "../common/StyledSelect";

interface ControlledSelectProps<T extends FieldValues>
	extends StyledSelectProps {
	name: FieldPath<T>;
	control: Control<T>;
}

export const ControlledSelect = <T extends FieldValues>({
	name,
	control,
	...props
}: ControlledSelectProps<T>) => {
	const { field } = useController({ name, control });

	const handleValueChange = (value: string) => {
		field.onChange(value);
	};

	return (
		<StyledSelect
			{...props}
			onValueChange={handleValueChange}
			value={field.value}
		/>
	);
};
